class detailSourceErrorCtrl {
    constructor($scope, $http, $uibModal, logger, httpRequest, Upload, $location, $timeout, $state, $stateParams, formvalidateApi) {
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })


        const { billId } = $stateParams
        httpRequest.get_getOvatSourceById(billId).then((res) => {
        	$scope.detail = res.data.value
        })
    }
}
detailSourceErrorCtrl.$inject = ['$scope', '$http', '$uibModal', 'logger', 'httpRequest', 'Upload', '$location', '$timeout', '$state', '$stateParams', 'formvalidateApi']
export default detailSourceErrorCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/sourceError/detailSourceErrorCtrl.js